"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var error_display_1 = require("../components/discovery/error_display");
var BillingMethodFormError = function () {
    return (React.createElement("div", { className: "site-wrapper site-wrapper--narrow ptb-2" },
        React.createElement(error_display_1.default, null)));
};
exports.default = BillingMethodFormError;
//# sourceMappingURL=billing_method_form_error.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/billing_method_form_error.js
// module id = Qh6p
// module chunks = 20 21